import { AuthActions } from "./actions";
import { SET_AUTH, UNSET_AUTH } from "./constants";

const initialState: AuthState = {
  user: null,
};

export const authReducer = (
  state = initialState,
  action: AuthActions
): AuthState => {
  switch (action.type) {
    case SET_AUTH: {
      return {
        ...state,
        user: action.user,
      };
    }

    case UNSET_AUTH: {
      return {
        ...state,
        user: null,
      };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/store/auth/reducer.ts